import { render, staticRenderFns } from "./BlockType13List.vue?vue&type=template&id=71a0e47e&scoped=true"
import script from "./BlockType13List.vue?vue&type=script&lang=ts"
export * from "./BlockType13List.vue?vue&type=script&lang=ts"
import style0 from "./BlockType13List.vue?vue&type=style&index=0&id=71a0e47e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71a0e47e",
  null
  
)

export default component.exports